import { useContext } from 'react';

import { IMappingToolContext, MappingToolContext } from './MappingToolContextProvider';

const useMappingToolContext = (): IMappingToolContext => {
  return useContext(MappingToolContext);
};

export default useMappingToolContext;
